import React from 'react'
import { Form } from 'react-bootstrap'

export default ({ name, label, to, onChange, checked, disabled, className, style, size="medium",required=false }) => {
  return (
    <Form.Check
      style={style} custom inline
      className={`text-grey ${size} ${className}`}
      type={"checkbox"}
      id={`${to}-${name}`}
      name={name}
      label={label}
      defaultChecked={checked}
      disabled={disabled}
      required={required}
    />
  )
}